function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
import { WDHVariation, WDHComponent } from '../../../../../wdh-foundation/wdh';
var HEADER = '.image-spot-element-header';
var ELEMENT = '.image-spot-element';
var CONTENT = '.image-spot-element-content';
var SPACER = '.spacer';
var TEXT = '.image-spot-element-text';
var IMAGE = '.image-spot-element-image';
var OPEN = 'open';
var WDHImageSpotAccordion = /*#__PURE__*/function (_WDHVariation) {
  function WDHImageSpotAccordion() {
    var variationClassName = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'accordion';
    _classCallCheck(this, WDHImageSpotAccordion);
    return _callSuper(this, WDHImageSpotAccordion, [variationClassName]);
  }
  _inherits(WDHImageSpotAccordion, _WDHVariation);
  return _createClass(WDHImageSpotAccordion, [{
    key: "init",
    value: function init(component) {
      var imageSpotElements = component.querySelectorAll(ELEMENT);
      this.restructureMarkup(imageSpotElements);
      this.addToggling(imageSpotElements);
    }
  }, {
    key: "resize",
    value: function resize(component) {
      var imageSpotElements = component.querySelectorAll(ELEMENT);
      this.resizeElements(imageSpotElements);
    }
  }, {
    key: "restructureMarkup",
    value: function restructureMarkup(imageSpotElements) {
      imageSpotElements.forEach(function (element) {
        var header = element.querySelector(HEADER);
        var image = element.querySelector(IMAGE);
        var text = element.querySelector(TEXT);
        header.insertAdjacentHTML('afterend', '<div class="image-spot-element-content"></div>');
        var contentWrapper = element.querySelector(CONTENT);
        contentWrapper.insertAdjacentHTML('afterend', '<div class="spacer"></div>');
        contentWrapper.appendChild(image);
        contentWrapper.appendChild(text);
        contentWrapper.insertAdjacentHTML('afterend', '<div class="mask"></div>');
        var $imgSrc = $(image.querySelectorAll('img')).attr('src');
        if (!$imgSrc) {
          image.style.display = 'none';
        }
      });
    }
  }, {
    key: "addToggling",
    value: function addToggling(imageSpotElements) {
      imageSpotElements.forEach(function (toggledElement) {
        var header = toggledElement.querySelector(HEADER);
        header.addEventListener('click', function () {
          var openThis = true;
          if (toggledElement.classList.contains(OPEN)) {
            openThis = false;
          }
          imageSpotElements.forEach(function (element) {
            element.classList.remove(OPEN);
          });
          if (openThis) toggledElement.classList.add(OPEN);
        });
      });
    }
  }, {
    key: "resizeElements",
    value: function resizeElements(imageSpotElements) {
      imageSpotElements.forEach(function (element) {
        var container = element.querySelector(CONTENT);
        var header = element.querySelector(HEADER);
        var spacer = element.querySelector(SPACER);
        var image = element.querySelector(IMAGE);
        var text = element.querySelector(TEXT);
        text.style.height = 'auto';
        container.style.width = "".concat(header.getBoundingClientRect().width, "px");
        spacer.style.height = '0px';
        var h = Math.max(0, container.getBoundingClientRect().height - image.getBoundingClientRect().height);
        spacer.style.height = "".concat(h, "px");
        while (h > 0 && image.getBoundingClientRect().bottom > text.getBoundingClientRect().bottom + 16) {
          h -= 1;
          spacer.style.height = "".concat(h, "px");
        }
      });
    }
  }]);
}(WDHVariation);
export default WDHImageSpotAccordion;